import React from 'react';
import anmaticsLogo from '../images/new/logo-ui.png';

const logoParts = [
    {
        className: 'logo-part-purple',
        clipPath: 'polygon(0 0, 50% 0, 50% 48%, 0 48%)'
    },
    {
        className: 'logo-part-teal',
        clipPath: 'polygon(50% 0, 100% 0, 100% 48%, 50% 48%)'
    },
    {
        className: 'logo-part-orange',
        clipPath: 'polygon(0 48%, 42% 48%, 42% 100%, 0 100%)'
    },
    {
        className: 'logo-part-blue',
        clipPath: 'polygon(42% 48%, 100% 48%, 100% 76%, 42% 76%)'
    },
    {
        className: 'logo-part-pink',
        clipPath: 'polygon(42% 76%, 100% 76%, 100% 100%, 42% 100%)'
    }
];

const AnimatedLogo = ({
    className = '',
    size = 52,
    label = 'Anmatics Technologies logo',
    priority = false
}) => (
    <span
        className={`animated-logo ${className}`.trim()}
        style={{ '--logo-size': `${size}px` }}
        role="img"
        aria-label={label}
    >
        <span className="logo-circuit-line logo-circuit-line-1" aria-hidden="true" />
        <span className="logo-circuit-line logo-circuit-line-2" aria-hidden="true" />
        <span className="logo-circuit-line logo-circuit-line-3" aria-hidden="true" />
        {logoParts.map((part) => (
            <span
                key={part.className}
                className={`logo-segment ${part.className}`}
                aria-hidden="true"
            >
                <span className="logo-segment-motion" style={{ '--segment-clip': part.clipPath }}>
                    <img
                        src={anmaticsLogo}
                        alt=""
                        width={size}
                        height={size}
                        decoding="async"
                        {...(priority ? { fetchPriority: 'high' } : { loading: 'lazy' })}
                    />
                </span>
            </span>
        ))}
    </span>
);

export default AnimatedLogo;
